import { render, staticRenderFns } from "./FullCourseFlag.vue?vue&type=template&id=8363cd4e&scoped=true"
import script from "./FullCourseFlag.vue?vue&type=script&lang=js"
export * from "./FullCourseFlag.vue?vue&type=script&lang=js"
import style0 from "./FullCourseFlag.vue?vue&type=style&index=0&id=8363cd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363cd4e",
  null
  
)

export default component.exports